/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Shot_ChangeInputs */



/**
* | output |
* | --- |
* | "Shot Change Detection" |
*
* @param {Signup_Compare_Shot_ChangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_shot_change = /** @type {((inputs?: Signup_Compare_Shot_ChangeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Shot_ChangeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Shot Change Detection")
	if (locale === "de") return /** @type {LocalizedString} */ ("Shot Change Detection")
	if (locale === "it") return /** @type {LocalizedString} */ ("Shot Change Detection")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Shot Change Detection")
	if (locale === "es") return /** @type {LocalizedString} */ ("Shot Change Detection")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Shot Change Detection")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Shot Change Detection")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Shot Change Detection")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Shot Change Detection")
	return /** @type {LocalizedString} */ ("Shot Change Detection")
});